import request from "../_redux/utils/request";

export async function createTimelineEvent(payload) {
  return request({
    url: "/timeline/events",
    method: "POST",
    body: payload
  });
}

export async function getTimelineEvents() {
  return request({
    url: "/timeline/events",
    method: "GET"
  });
}

export async function getDashboardSummary() {
  return request({
    url: "/timeline/dashboard",
    method: "GET"
  });
}

export async function getInsights() {
  return request({
    url: "/insights",
    method: "GET"
  });
}
